import React from "react"
import { CustomRow } from "../../../spacings"
import { PartialGridItemProduct } from "../../Product/ProductGridItem/types"
import ProductGridWrapper from "../../Product/ProductGridWrapper"

export interface ShopProductsProps {
  products: PartialGridItemProduct[]
  colSizeXs?: number
  colSizeMd?: number
  colSizeLg?: number
  colSizeXl?: number
}

const ShopProducts = ({
  products,
  colSizeXs,
  colSizeMd,
  colSizeLg,
  colSizeXl,
}: ShopProductsProps) => {
  return (
    <div>
      <CustomRow>
        <ProductGridWrapper
          products={products}
          xsColSize={colSizeXs}
          mdColSize={colSizeMd}
          lgColSize={colSizeLg}
          xlColSize={colSizeXl}
          className="mb-16 sm:mb-10"
        />
      </CustomRow>
    </div>
  )
}

export default ShopProducts
